module.exports = __webpack_public_path__ + "statics/img/history.f012ed34.png";